module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// /~/babel-polyfill/~/core-js/modules/_is-object.js
// module id = 33
// module chunks = 0